import { AccountWithdrawn } from "components";
import { Outlet } from "react-router-dom";

export default function Page() {
    return (
        <div className="flex w-full h-full items-center justify-center">
            <Outlet />
        </div>
    )
}